import A from "@/i18n/console_a";
import B from "@/i18n/console_b";

// The console dictionary (EN source -> FR, ES). Strings not listed here show in English.
const CONSOLE_DICT = { langs: ["fr", "es"], entries: { ...A, ...B } };
export default CONSOLE_DICT;
